import * as yup from 'yup';


export const searchDirectoryFormValidation = yup.object().shape(
  {
    searchTerm: yup.string(),
  },
);
